module.exports = __webpack_public_path__ + "static/desk_coder-526e76afeab48e97e4e48ff222ae7ae0.svg";